module.exports = __webpack_public_path__ + "img/rectangle-vertical.93cca231.svg";